import React, { useState, useEffect, useCallback, useRef } from "react";
import { TextField } from "@material-ui/core";
import { useSnackbar } from "notistack";
import { deleteActivity } from "../../../services/activityService";
import { deleteRequirement } from "../../../services/requirementService";
import { getComponentActivities } from "../../../services/componentActivitiesService";
import { getComponentRequirements } from "../../../services/componentRequirementsService";
import ModalDeleteActivity from "./activities/modalDeleteActivity";
import ModalDeleteRequirement from "./requirements/modalDeleteRequirement";
import { notifications } from "../../../utils/messages";
import { useForm } from "../../../hooks/useForm";
import RequirementsTableI from "./requirements/requirementsTableI";
import ActivitiesTableI from "./activities/activitiesTableI";

const SingleComponentI = React.memo(
  ({
    comp: component,
    plannedBudget,
    executedBudget,
    handleSubmit,
    onOpenDelete,
  }) => {
    const isMounted = useRef(true);
    const initialState = {
      id: component.id,
      name: component.name,
      goal: component.goal || "",
      project_id: component.project_id,
    };
    const [formValues, handleInputChange] = useForm(initialState);
    const { name, goal } = formValues;
    const [isOpen, setIsOpen] = useState(false);
    const [idActivityToDelete, setIdActivityToDelete] = useState("");
    const [isOpenRequirement, setIsOpenRequirement] = useState(false);
    const [idRequirementToDelete, setIdRequirementToDelete] = useState("");

    const [activities, setActivities] = useState([]);
    const [requirements, setRequirements] = useState([]);
    const { enqueueSnackbar } = useSnackbar();

    const populateActivities = useCallback(async (idComponent) => {
      const { data: activities } = await getComponentActivities(idComponent);
      setActivities(activities);
    }, []);
    const populateRequirements = useCallback(async (idComponent) => {
      const { data: requirements } = await getComponentRequirements(
        idComponent
      );
      setRequirements(requirements);
    }, []);

    const handleOpenModal = (activityId) => {
      setIsOpen(true);
      setIdActivityToDelete(activityId);
    };

    const handleCloseModal = () => {
      setIsOpen(false);
    };

    const doDeleteActivity = async (activityId) => {
      const originalActivities = [...activities];
      handleCloseModal();
      try {
        const newActivities = originalActivities.filter(
          (act) => act.id !== activityId
        );
        setActivities(newActivities);
        await deleteActivity(activityId);
        enqueueSnackbar(notifications.DELETE_SUCCESS, { variant: "success" });
        await populateRequirements(component.id);
        await plannedBudget();
        await executedBudget();
      } catch (ex) {
        //console.log("Catch error", ex.response);
        setActivities(originalActivities);
        enqueueSnackbar(`${ex.response.data.message}`, { variant: "error" });
      }
    };

    const handleOpenModalRequirement = (requirementId) => {
      setIsOpenRequirement(true);
      setIdRequirementToDelete(requirementId);
    };

    const handleCloseModalRequirement = () => {
      setIsOpenRequirement(false);
    };

    const doDeleteRequirement = async (requirementId) => {
      const originalRequirements = [...requirements];
      handleCloseModalRequirement();
      try {
        const newRequirements = originalRequirements.filter(
          (req) => req.id !== requirementId
        );
        setRequirements(newRequirements);
        await deleteRequirement(requirementId);
        await plannedBudget();
        await executedBudget();
        enqueueSnackbar(notifications.DELETE_SUCCESS, { variant: "success" });
        // await populateRequirements(component.id);
      } catch (ex) {
        //console.log("Catch error", ex.response);
        setRequirements(originalRequirements);
        enqueueSnackbar(`${ex.response.data.message}`, { variant: "error" });
      }
    };

    useEffect(() => {
      return () => {
        isMounted.current = false;
      };
    }, []);

    useEffect(() => {
      if (isMounted.current) {
        populateActivities(component.id);
        populateRequirements(component.id);
      } else {
        //console.log("Populate Activities and Requirements no se llamó");
      }
    }, [populateActivities, populateRequirements, component.id]);

    return (
      <>
        <TextField
          defaultValue=" "
          margin="dense"
          name="name"
          label="Nombre del componente"
          type="text"
          variant="outlined"
          size="small"
          fullWidth
          value={name}
          onChange={handleInputChange}
        />
        <TextField
          defaultValue=" "
          margin="dense"
          name="goal"
          label="Meta del componente"
          type="text"
          variant="outlined"
          size="small"
          fullWidth
          value={goal}
          onChange={handleInputChange}
        />

        <br />
        <small style={{ color: "white" }}>
          {" "}
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;{" "}
        </small>
        <ActivitiesTableI
          datas={activities}
          component={component}
          openModalEliminar={(a) => handleOpenModal(a)}
          populateActivities={populateActivities}
        />
        <ModalDeleteActivity
          handleCloseModal={() => handleCloseModal()}
          isOpen={isOpen}
          idActivityToDelete={idActivityToDelete}
          onDeleteActivity={(a) => doDeleteActivity(a)}
        />
        <div className="separator"></div>

        <RequirementsTableI
          datas={requirements}
          component={component}
          activities={activities}
          populateRequirements={populateRequirements}
          plannedBudget={plannedBudget}
          executedBudget={executedBudget}
          openModalEliminar={(a) => handleOpenModalRequirement(a)}
        />
        <ModalDeleteRequirement
          handleCloseModal={() => handleCloseModalRequirement()}
          isOpen={isOpenRequirement}
          idRequirementToDelete={idRequirementToDelete}
          onDeleteRequirement={(a) => doDeleteRequirement(a)}
        />
      </>
    );
  }
);

export default SingleComponentI;
